import snackBarReducer from '../components/snackBar/reducer/reducers'

const reducers = {
	snackBar: snackBarReducer
}

export default reducers
